import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const CostForm_FixedCost_Fragment = graphql(`
  fragment CostForm_FixedCost_Fragment on FixedCost {
    _id
    typeId
    codingConfig {
      kind
      strategyId
      ... on CodingConfigManual {
        code
      }
      ...CodeCmp_CodingConfig_Fragment
    }
    code
    label
    costMarginId
    title
    content
    statusId
    amount {
      value
      currencyId
    }
  }
`);

export type CostForm_FixedCostData = ResultOf<
  typeof CostForm_FixedCost_Fragment
>;

// The form edits a readable amount: a cost whose amount is confidential is not editable.
export type CostForm_FixedCost = Omit<CostForm_FixedCostData, 'amount'> &
  Readonly<{ amount: NonNullable<CostForm_FixedCostData['amount']> }>;

export type CostForm_FixedCost_Amount = CostForm_FixedCost['amount'];
